import { render, staticRenderFns } from "./PrivateThought.vue?vue&type=template&id=7c6a8d65&scoped=true&"
import script from "./PrivateThought.vue?vue&type=script&lang=js&"
export * from "./PrivateThought.vue?vue&type=script&lang=js&"
import style0 from "./PrivateThought.vue?vue&type=style&index=0&id=7c6a8d65&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a8d65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VListItem,VListItemContent,VListItemTitle,VRow})
